<template>
  <div>
    <h4 class="title">
      رزرو غذای سفارشی
    </h4>
    <b-overlay :show="calendarProgress">
      <persian-calendar
        :events-list="events"
        :display-period.sync="period"
        :min-date="min"
        disable-past-days
        class="cursor-pointer"
        @on-day-click="onDayClick"
      >
        <template
          slot="event"
          slot-scope="i"
        >
          <div
            :key="i.value.id"
            style="padding: 5px;"
            :class="i.value.classes"
            :style="`top:${i.top};background-color:${i.value.color};`"
            class="vpc_event"
            @click="onEventClick(i.value)"
          >
            <!--  Anything You Wish -->
            <span
              class="vpc_event-title"
              style="padding: 5px!important"
              :class="i.value.classes"
            >
              {{ i.value.title }}
            </span>
          </div>
        </template>
      </persian-calendar>

    </b-overlay>
    <b-modal
      v-model="showModal"
      centered
      :title="`منوی غذا (${menuTitle})`"
      size="lg"
      :no-close-on-backdrop="true"
      hide-footer
      @close="clearSpecial"
    >
      <b-tabs content-class="mt-1">
        <b-tab v-if="!hideActions">
          <template #title>
            <feather-icon icon="FilePlusIcon" />
            <span>غذای سفارشی</span>
          </template>
          <validation-observer
            ref="refFormObserver"
            #default="{invalid}"
          >
            <b-form @submit.prevent="book">
              <b-row>
                <b-col md="6">
                  <b-overlay :show="foodDayList.length === 0">

                    <b-form-group>
                      <label for="food_id">
                        نام غذای روز
                      </label>
                      <v-select
                        v-model="special.food_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        :options="foodDayList"
                        :reduce="food => food.id"
                      />
                    </b-form-group>
                  </b-overlay>
                </b-col>
                <b-col md="6">
                  <b-overlay :show="foodList.length === 0">
                    <b-form-group description="در صورت نیاز، می توان بجای غذای روز از غذاهای دیگر انتخاب کنید">
                      <label for="food_id">
                        نام غذا
                      </label>
                      <v-select
                        v-model="special.extra_food_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        :options="foodList"
                        :reduce="food => food.id"
                      />
                    </b-form-group>
                  </b-overlay>
                </b-col>
                <b-col md="6">
                  <b-overlay :show="mealList.length === 0">
                    <validation-provider
                      #default="{errors}"
                      name="وعده غذایی"
                      rules="required"
                    >
                      <b-form-group>
                        <label for="organization_id">
                          وعده غذایی
                        </label>
                        <v-select
                          v-model="special.meal_id"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          label="name"
                          :options="mealList"
                          :reduce="meal => meal.id"
                          :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-overlay>
                </b-col>
                <b-col md="6">
                  <b-overlay :show="organizationList.length === 0">
                    <validation-provider
                      #default="{errors}"
                      name="واحد سازمانی"
                      rules="required"
                    >
                      <b-form-group>
                        <label for="organization_id">
                          واحد سازمانی
                        </label>
                        <v-select
                          v-model="special.organization_id"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          label="name"
                          :options="organizationList"
                          :reduce="organization => organization.id"
                          :state="errors.length > 0 ?false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>

                      </b-form-group>
                    </validation-provider>
                  </b-overlay>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    #default="{errors}"
                    name="نام درخواست دهنده"
                    rules="required"
                  >
                    <b-form-group>
                      <label for="name">
                        نام درخواست دهنده
                      </label>
                      <b-form-input
                        id="name"
                        v-model="special.applicant_name"
                        placeholder="نام درخواست دهنده را وارد نمایید"
                        trim
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    #default="{errors}"
                    name="تعداد"
                    rules="required"
                  >
                    <b-form-group>
                      <label for="name">
                        تعداد
                      </label>
                      <b-form-input
                        id="name"
                        v-model="special.count"
                        type="number"
                        placeholder="تعداد غذا را وارد نمایید"
                        trim
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>

              </b-row>
              <hr>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="success"
                type="submit"
                :disabled="onCreateProgress"
              >
                {{ onCreateProgress ? 'در حال ثبت' : 'ثبت' }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-secondary"
                type="button"
                class="float-right"
                @click="closeModal"
              >
                انصراف
              </b-button>

            </b-form>
          </validation-observer>
        </b-tab>
        <b-tab
          lazy
          @click="getMenuSelected"
        >
          <template #title>
            <feather-icon icon="MenuIcon" />
            <span>منو</span>
          </template>
          <b-overlay :show="onTableProgress">

            <b-table
              :fields="fields"
              :items="items"
              hover
              striped
              responsive
            >
              <template #table-busy>
                <div class="text-center text-info my-2">
                  <b-spinner class="align-middle" />
                  <strong> درحال دریافت اطلاعات...</strong>
                </div>
              </template>

              <template #cell(isActive)="data">
                <b-avatar
                  :id="`user-row-${data.item.id}`"
                  size="32"
                  :variant="data.value ? 'light-success': 'light-danger'"
                >
                  <feather-icon
                    :icon="data.value ? 'CheckIcon': 'XIcon'"
                  />
                </b-avatar>
              </template>
              <template #cell(action)="data">

                <b-button
                  v-if="!hideActions"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-warning"
                  class="btn-icon rounded-circle"
                  @click="editMenu(data.item.id)"
                >
                  <feather-icon
                    icon="EditIcon"
                    class="text-warning"
                  />
                </b-button>
              </template>

            </b-table>
          </b-overlay>
        </b-tab>
      </b-tabs>
    </b-modal>
    <b-modal
      v-model="editModal"
      centered
      title="ویرایش منو"
      size="lg"
      :ok-disabled="onProgress"
      cancel-variant="outline-secondary"
      ok-title="ویرایش"
      cancel-title="انصراف"
      :no-close-on-backdrop="true"
      @ok="updateSpecial"
      @cancel="clearSpecial"
      @close="clearSpecial"
    >

      <validation-observer
        ref="refFormUpdateObserver"
        #default="{invalid}"
      >
        <b-form>
          <b-row>
            <b-col md="6">
              <b-overlay :show="foodDayList.length === 0">

                <b-form-group>
                  <label for="food_id">
                    نام غذای روز
                  </label>
                  <v-select
                    v-model="special.food_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="foodDayList"
                    :reduce="food => food.id"
                  />
                </b-form-group>
              </b-overlay>
            </b-col>
            <b-col md="6">
              <b-overlay :show="foodList.length === 0">
                <b-form-group description="در صورت نیاز، می توان بجای غذای روز از غذاهای دیگر انتخاب کنید">
                  <label for="food_id">
                    نام غذا
                  </label>
                  <v-select
                    v-model="special.extra_food_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="foodList"
                    :reduce="food => food.id"
                  />
                </b-form-group>
              </b-overlay>
            </b-col>
            <b-col md="6">
              <b-overlay :show="mealList.length === 0">
                <validation-provider
                  #default="{errors}"
                  name="وعده غذایی"
                  rules="required"
                >
                  <b-form-group>
                    <label for="organization_id">
                      وعده غذایی
                    </label>
                    <v-select
                      v-model="special.meal_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="mealList"
                      :reduce="meal => meal.id"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-overlay>
            </b-col>
            <b-col md="6">
              <b-overlay :show="organizationList.length === 0">
                <validation-provider
                  #default="{errors}"
                  name="واحد سازمانی"
                  rules="required"
                >
                  <b-form-group>
                    <label for="organization_id">
                      واحد سازمانی
                    </label>
                    <v-select
                      v-model="special.organization_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="organizationList"
                      :reduce="organization => organization.id"
                      :state="errors.length > 0 ?false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>

                  </b-form-group>
                </validation-provider>
              </b-overlay>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{errors}"
                name="نام درخواست دهنده"
                rules="required"
              >
                <b-form-group>
                  <label for="name">
                    نام درخواست دهنده
                  </label>
                  <b-form-input
                    id="name"
                    v-model="special.applicant_name"
                    placeholder="نام درخواست دهنده را وارد نمایید"
                    trim
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>

                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{errors}"
                name="تعداد"
                rules="required"
              >
                <b-form-group>
                  <label for="name">
                    تعداد
                  </label>
                  <b-form-input
                    id="name"
                    v-model="special.count"
                    type="number"
                    placeholder="تعداد غذا را وارد نمایید"
                    trim
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

          </b-row>

        </b-form>
      </validation-observer>

    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BInputGroup,
  BInputGroupAppend, BFormInvalidFeedback, BFormCheckbox, BModal, BTabs, BTab, BButton,
  BTable, BDropdownItem, BAvatar, BBadge, BSpinner, BDropdown,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import farsi from 'vee-validate/dist/locale/fa'
import PersianCalendar from '@/views/components/reservation/PersianCalendar.vue'
import { parsMomentEvent, PersianNowDate } from '@/libs/utils'
import formValidation from '@core/comp-functions/forms/form-validation'
import { required, required_if } from '@core/utils/validations/validations'

export default {
  name: 'Reservation',
  components: {
    ValidationProvider,
    ValidationObserver,
    BDropdown,
    BSpinner,
    BBadge,
    BAvatar,
    BDropdownItem,
    BTab,
    BTabs,
    BFormCheckbox,
    BFormInvalidFeedback,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    VSelect,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
    BModal,
    PersianCalendar,
    BButton,
    BTable,
  },
  directives: {
    ripple,
  },
  data() {
    return {
      onProgress: false,
      onCreateProgress: false,
      calendarProgress: false,
      onTableProgress: false,
      showModal: false,
      period: 'month',
      min: this.$moment(new Date(), 'jYYYY/jMM/jDD'),
      events: [],
      selectedDay: null,
      menuTitle: '',
      fields: [
        {
          key: 'food',
          label: 'نام غذا',
        },
        {
          key: 'meal',
          label: 'وعده غذایی',
        },
        {
          key: 'organization',
          label: 'واحد سازمانی',
        },
        {
          key: 'applicantName',
          label: 'نام متقاضی',
        },
        {
          key: 'count',
          label: 'تعداد',
        },
        {
          key: 'creator.name',
          label: 'سازنده',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      items: [],
      editModal: false,
      special: {},
      foodDayList: [],
      food_id: null,
      mealList: [],
      meal_id: null,
      extra_food_id: null,
      foodList: [],
      requester_name: null,
      count: null,
      organizationList: [],
      organization_id: null,
      hideActions: false,
    }
  },
  created() {
    localize('fa', {
      messages: farsi.messages,
    })
  },
  mounted() {
    this.getEvents()
    this.getFoods()
    this.getMeal()
    this.getOrganization()
  },
  methods: {
    async getEvents() {
      this.calendarProgress = true
      await this.$http.get('special-reservations')
        .then(({ data }) => {
          if (data.status) {
            this.events = data.menus.map(event => parsMomentEvent(event, this.$moment))
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت لیست غذا با خطا مواجه شد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? error.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })

      this.calendarProgress = false
    },
    onEventClick(e) {
      this.onDayClick(this.$moment(e.startDateTime))
    },
    onDayClick(event) {
      this.special = {}
      this.selectedDay = event
      this.menuTitle = event.format('jDD jMMMM jYYYY')
      this.hideActions = event.isBefore(this.$moment(), 'day')
      if (this.hideActions) {
        this.getMenuSelected()
      } else {
        this.getTodayFood()
      }
      this.showModal = true
    },
    getMenuSelected() {
      this.onTableProgress = true
      this.$http.get(`special-reservations/get-menu?date=${PersianNowDate(this.selectedDay, false, true)}`)
        .then(({ data }) => {
          if (data.status) {
            this.items = data.items
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت لیست غذا با خطا مواجه شد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? error.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
        .finally(() => {
          this.onTableProgress = false
        })
    },
    getTodayFood() {
      this.onTableProgress = true
      this.$http.get(`special-reservations/get-date-food?date=${PersianNowDate(this.selectedDay, false, true)}`)
        .then(({ data }) => {
          if (data.status) {
            this.foodDayList = data.food
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت لیست غذا با خطا مواجه شد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? error.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
        .finally(() => {
          this.onTableProgress = false
        })
    },

    closeModal() {
      this.showModal = false
      this.clearSpecial()
    },
    clearSpecial() {
      this.special = {}
    },
    deleteBook(id) {
      this.$http.delete(`special-reservations/${id}`,
        {
          params: {
            reservation_date: PersianNowDate(this.selectedDay, false, true),
          },
        })
        .then(({ data }) => {
          if (data.status) {
            this.items = this.items.map(item => {
              if (item.id === data.item.id) {
                return data.item
              }
              return item
            })

            this.events = this.events.map(event => {
              if (event.id === data.menu.id) {
                return parsMomentEvent(data.menu, this.$moment)
              }
              return event
            })
            this.showModal = false

            this.$bvToast.toast('حذف رزرو با موفقیت انجام شد.', {
              title: 'رزرو',
              toaster: 'b-toaster-top-right',
              variant: 'success',
            })
          } else {
            this.$bvToast.toast(data.message, {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? error.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
        .finally(() => {
          this.onProgress = false
        })
    },
    book() {
      this.$refs.refFormObserver.validate()
        .then(success => {
          if (success) {
            this.$http.post('special-reservations',
              {
                ...this.special,
                reservation_date: PersianNowDate(this.selectedDay, false, true),
              })
              .then(({ data }) => {
                if (data.status) {
                  this.items = this.items.map(item => {
                    if (item.id === data.tableItem.id) {
                      return data.tableItem
                    }
                    return item
                  })
                  this.clearSpecial()
                  this.showModal = false

                  this.$bvToast.toast('رزرو با موفقیت انجام شد.', {
                    title: 'رزرو',
                    toaster: 'b-toaster-top-right',
                    variant: 'success',
                  })
                } else {
                  this.$bvToast.toast(data.message, {
                    title: 'خطا در دریافت اطلاعات',
                    toaster: 'b-toaster-top-right',
                    variant: 'danger',
                  })
                }
              })
              .catch(error => {
                this.$bvToast.toast(error.response.data.message ?? error.message, {
                  title: 'خطا در دریافت اطلاعات',
                  toaster: 'b-toaster-top-right',
                  variant: 'danger',
                })
              })
              .finally(() => {
                this.onProgress = false
              })
          }
        })
    },
    getFoods() {
      this.$http.get('foods', {
        params: {
          result: 'all',
          only_active: 1,
          order: 'name',
        },
      })
        .then(({ data }) => {
          if (data.status) {
            this.foodList = data.foods
          } else {
            this.$bvToast.toast('دریافت لیست غذا با خطا مواجه شد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
    },
    getMeal() {
      this.$http.get('meals?result=all')
        .then(({ data }) => {
          if (data.status) {
            this.mealList = data.meals
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت لیست وعده غذایی با خطا مواجه شد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
    },
    updateSpecial(e) {
      e.preventDefault()
      this.$refs.refFormUpdateObserver.validate()
        .then(success => {
          if (success) {
            this.onProgress = true
            this.$http.put(`special-reservations/${this.special.id}`, this.special)
              .then(({ data }) => {
                this.editModal = false
                this.clearSpecial()
                this.items = this.items.map(item => {
                  if (item.id === data.tableItem.id) {
                    return data.tableItem
                  }
                  return item
                })

                this.editModal = false
                if (data.status) {
                  this.$bvToast.toast('غذا با موفقیت ایجاد شد', {
                    title: 'موفقیت',
                    toaster: 'b-toaster-top-right',
                    variant: 'success',
                  })
                } else {
                  this.$bvToast.toast(data.message ?? 'در غذا خطایی رخ داده', {
                    title: 'حطا',
                    toaster: 'b-toaster-top-right',
                    variant: 'danger',
                  })
                }
              })
              .catch(error => {
                this.$bvToast.toast(error.response.data.message ?? error.message, {
                  title: 'خطا در دریافت اطلاعات',
                  toaster: 'b-toaster-top-right',
                  variant: 'danger',
                })
              })
              .finally(() => {
                this.onProgress = false
              })
          }
        })
    },
    getOrganization() {
      this.$http.get('organizations?result=all')
        .then(({ data }) => {
          if (data.status) {
            this.organizationList = data.organizations
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت لیست نقش ها با خطا مواجه شد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
    },
    editMenu(id) {
      this.$http.get(`special-reservations/${id}`)
        .then(({ data }) => {
          if (data.status) {
            this.special = data.menu

            this.editModal = true
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت لیست غذا با خطا مواجه شد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
    },

  },
  setup() {
    const {
      getValidationState,

    } = formValidation(name)

    return {
      getValidationState,
    }
  },
}
</script>

<style>

</style>
